module.exports = __webpack_public_path__ + "img/0023.1378de17.jpg";